<div class="cards">
    <div class="card" *ngFor="let card of cards$ | async" (click)="goToDetails(card)">
      <img [src]="card.image" [alt]="card.title" class="card-image">
      <p class="card__text">{{ card.title }}</p>
      <p class="card__subtitle" [innerHTML]="card.subtitle"></p>
    </div>
  </div>